import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "account" }

import { searchFormConfig } from './config/search.config'
import { contentTableConfig } from './config/content.config'
import { modalConfig } from './config/modal.config'
import { usePageSearch } from '@/hooks/userPageSearch'
import { usePageModal } from '@/hooks/usePageModal'
import { getListData } from '@/service/main/system'
import { ref } from 'vue'
import { initEmptyParam } from '@/hooks/useInitParam'


export default /*#__PURE__*/_defineComponent({
  __name: 'employee',
  setup(__props) {

initEmptyParam()

const getRoleList = async () => {
  let roleData = await getListData('/main/role/listAll', {})

  const roleItem = modalConfig.formItems.find(
    (item) => item.field === 'roleIds'
  )
  roleItem!.options = roleData.list.map((item: any) => {
    return { title: item.displayName, value: item.id }
  })
}

getRoleList()

const getDeptList = async () => {
  const depts = await getListData('/main/dept/listWithOutEmp', {})
  const deptSearchItem = searchFormConfig.formItems.find(
    (item) => item.field === 'deptId'
  )
  const deptContentItem = modalConfig.formItems.find(
    (item) => item.field === 'deptId'
  )
  const option = depts.map((item: any) => {
    return { title: item.name, value: item.id }
  })
  deptSearchItem!.options = option
  deptContentItem!.options = option
}

getDeptList()

const modalTitle = ref('新增')

const newCb = () => {
  const usernameItem = modalConfig.formItems.find(
    (item) => item.field === 'empNo'
  )
  usernameItem!.isDisabled = false

  modalTitle.value = '新增员工'
}

const editCb = () => {
  const usernameItem = modalConfig.formItems.find(
    (item) => item.field === 'empNo'
  )
  usernameItem!.isDisabled = true

  modalTitle.value = '编辑用户'
}

const [pageModalRef, defaultInfo, handleNewData, handleEditData] = usePageModal(
  newCb,
  editCb
)
const [pageContentRef, handleResetClick, handleSearchClick] = usePageSearch()

return (_ctx: any,_cache: any) => {
  const _component_PageSearch = _resolveComponent("PageSearch")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_PageContent = _resolveComponent("PageContent")!
  const _component_PageModal = _resolveComponent("PageModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PageSearch, {
      searchFormConfig: _unref(searchFormConfig),
      onResetBtnClick: _unref(handleResetClick),
      onSearchBtnClick: _unref(handleSearchClick)
    }, null, 8, ["searchFormConfig", "onResetBtnClick", "onSearchBtnClick"]),
    _createVNode(_component_PageContent, {
      ref_key: "pageContentRef",
      ref: pageContentRef,
      contentTableConfig: _unref(contentTableConfig),
      pageName: "employee",
      deleteTip: "确认删除此员工吗？",
      onNewBtnClick: _unref(handleNewData),
      onEditBtnClick: _unref(handleEditData)
    }, {
      empTag: _withCtx((scope) => [
        _createElementVNode("span", null, _toDisplayString(scope.row.empTag?scope.row.empTag=='0'?'518':'投教':''), 1)
      ]),
      manager: _withCtx((scope) => [
        _createElementVNode("span", null, _toDisplayString(scope.row.isManager == '1' ? '经理' : '员工'), 1)
      ]),
      lastLoginTime: _withCtx((scope) => [
        _createElementVNode("span", null, _toDisplayString(_ctx.$filters.formatTime(scope.row.lastLoginTime)), 1)
      ]),
      status: _withCtx((scope) => [
        _createVNode(_component_el_button, {
          size: "mini",
          plain: "",
          type: scope.row.status == 1 ? 'success' : 'danger'
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(scope.row.status == 1 ? '正常' : '禁用'), 1)
          ]),
          _: 2
        }, 1032, ["type"])
      ]),
      _: 1
    }, 8, ["contentTableConfig", "onNewBtnClick", "onEditBtnClick"]),
    _createVNode(_component_PageModal, {
      ref_key: "pageModalRef",
      ref: pageModalRef,
      defaultInfo: _unref(defaultInfo),
      modalConfig: _unref(modalConfig),
      title: modalTitle.value,
      validOtherInfo: () => true,
      pageName: "employee"
    }, null, 8, ["defaultInfo", "modalConfig", "title"])
  ]))
}
}

})